// extracted by mini-css-extract-plugin
export default {"container":"dashboard_container__QZYQc","body":"dashboard_body__wTbnx","admin":"dashboard_admin__yR+re","manager":"dashboard_manager__VmC0u","loadSpin":"dashboard_loadSpin__wvjCQ"};